// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { SiOkta as RawSiOkta } from "react-icons/si";
export const SiOkta = /* @__PURE__ */ createIcon(RawSiOkta, "SiOkta", 0);
